import GrtLoading from '@/components/GrtLoading/GRTLoading';
import { useEffect } from 'react';

import { handleDongGuanLogin } from '@/api/login';
import withRouter from '@/components/withRouter';
import { updateCookie } from '@/utils/index';
import { isMobile } from 'react-device-detect';
import Toast from '@/components/Toast';
const DongguanLogin = (props) => {
    let code = props.searchParams.get('code');
    const thirdLogin = async () => {
        let data = {
                code: code
            },
            res = await handleDongGuanLogin(data);
        if (res && res.success) {
            updateCookie(Object.assign(res.data, { domain: window.location.host }));
            let business_id = res?.data?.business_id,
             { protocol, host } = window.location,
             url = isMobile ? `/mobile/teach-business?template_id=104&business_id=${business_id}&course_type=104` : `/web/104/${business_id}/home`;
            window.location.replace(`${protocol}//${host}${url}`);
        } else {
            Toast.error(res.msg || '登录失败');
        }
    };
    useEffect(() => {
        if (code) {
            thirdLogin();
        }
    }, [code]);
    return (
        <div style={{ height: window.innerHeight, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <GrtLoading></GrtLoading>
        </div>
    );
};

export default withRouter(DongguanLogin);
